import { Component, OnInit, Input } from '@angular/core';
import { OrderModel } from 'src/app/store/order/model';

@Component({
  selector: 'app-order-preview',
  templateUrl: './order-preview.component.html',
  styleUrls: ['./order-preview.component.scss'],
  standalone: false,
})
export class OrderPreviewComponent implements OnInit {
  @Input('order') public order: OrderModel;

  constructor() {}

  ngOnInit(): void {}
}
